import { IRoad } from '../types/geo';
import { IGetVillageListRequestSchema } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { DEFAULT_ROAD_DISTANCE, DEFAULT_STATION_DISTANCE, SAVED_FILTERS_KEYS } from '../interfaces/filters';
import { parseToNumberList } from './filters';
import { getRoadFullName, ONLY_VILLAGES_REGEXP } from './geo';
import { pick } from './pick';

export const getRoadDistanceLabel = (distance: number) => `до ${distance} км от посёлка до шоссе`;

export const getStationDistanceLabel = (distance: number) => `до ${distance} км от посёлка до станции`;

export const getRoadLabel = (road: IRoad) => {
  const label = getRoadFullName(road);

  return label.length > 40 ? label.slice(0, 40) + '...' : label;
};

export const clearSavedFilters = (filters: IGetVillageListRequestSchema) => {
  const allowedKeys = Object.keys(filters).filter(key => !SAVED_FILTERS_KEYS.includes(key));

  return pick(filters, allowedKeys) as IGetVillageListRequestSchema;
};

export const parseRoadStation = (text: string | undefined, data: { id: number }[], enabled: boolean) => {
  const validIds = data.map(({ id }) => id);

  return enabled ? parseToNumberList(text).filter(id => validIds.includes(id)) : undefined;
};

export const isDistanceDefault = <T>(key: string, value: T) => {
  if (typeof value !== 'number') {
    return false;
  }

  return (
    (key === 'roadDistance' && value === DEFAULT_ROAD_DISTANCE) ||
    (key === 'stationDistance' && value === DEFAULT_STATION_DISTANCE)
  );
};

export const isVillageQuery = (textValue: string) => ONLY_VILLAGES_REGEXP.test(textValue);
